<dialog
  *ngIf="showModal"
  class="pop-up !p-0 laptop:!p-[initial] !z-[1060] flex flex-col"
  [open]="showModal"
  aria-labelledby="pop-up-title"
  aria-modal="true"
  role="dialog"
>
  <!-- Mobile/Tablet Close Bar -->
  <div
    class="bg-surface-navigation w-full py-4 px-16 flex justify-end items-center laptop:hidden"
    id="mach-core-langselector-mobile-close-bar"
  >
    <button
      (click)="close()"
      class="bg-surface-navigation border-0 text-inverse p-8 text-label-md-semibold"
      id="mach-core-langselector-mobile-close-button"
    >
      Close
    </button>
  </div>

  <div
    class="pop-up-box !w-screen !min-h-[calc(100vh-3.5rem)] laptop:!w-[768px] laptop:!h-auto laptop:!min-h-[500px] !rounded-none laptop:!rounded-[8px] !px-0"
    id="mach-core-langselector"
  >
    <svg
      class="laptop:hidden text-brand-red absolute top-[2px] right-0"
      width="80"
      height="64"
      viewBox="0 0 80 64"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-8"
        width="80"
        height="72"
      >
        <rect y="-8" width="79.2453" height="72" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M78.2057 -8.01135L62.0235 14.7275L43.997 14.815L57.1839 1.78898L78.2057 -8.01135Z"
          fill="#E01933"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M34.1016 36.1808L22.5412 29.1015L26.9955 21.137L37.305 19.2447L34.1016 36.1808Z"
          fill="#E01933"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M44.0621 14.8803L49.2343 58.1151L78.3127 -7.98438L44.0621 14.8803Z"
          fill="#991933"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5555 29.1348L45.017 64.681L37.3545 19.2578L22.5555 29.1348Z"
          fill="#991933"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M78.1606 -8.15473L7.58616 -7.73853L43.909 14.7105L78.1606 -8.15473Z"
          fill="#E01933"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00128355 -6.49024L22.4622 29.0552L37.2613 19.1782L0.00128355 -6.49024Z"
          fill="#E01933"
        />
      </g>
    </svg>
    <div
      class="pop-up-box-header !border-b-0 px-[24px]"
      id="mach-core-langselector-header"
    >
      <h2
        id="mach-core-langselector-header-popup-title"
        class="text-label-xl-semibold"
      >
        {{ content.title }}
      </h2>
      <button
        (click)="close()"
        class="pop-up-box-header-close-button hidden laptop:block"
        aria-label="Close pop-up"
        tabindex="0"
        id="mach-core-langselector-close"
      >
        <div class="pop-up-box-header-close-button-icon"></div>
      </button>
    </div>

    <div class="pop-up-box-content !mt-0 px-[24px] pt-[15px]">
      <!-- Language change link -->
      <div *ngIf="content.displayButtonText" class="mb-24">
        <a
          tabindex="0"
          (click)="
            displayContentLanguage(
              content.clsLanguageCodeToChange + '-' + content.currentCountryCode
            )
          "
          (keydown.enter)="
            displayContentLanguage(
              content.clsLanguageCodeToChange + '-' + content.currentCountryCode
            )
          "
          class="link link-md"
        >
          {{ content.displayButtonText }}
        </a>
      </div>

      <!-- Search -->
      <div class="mb-24">
        <div class="relative w-full" id="mach-core-langselector-search">
          <input
            #searchField
            (focus)="onSearchFieldFocus()"
            (focusout)="onSearchFieldFocusout()"
            (input)="onSearchValueChanged(searchField.value)"
            [(ngModel)]="searchValue"
            id="mach-core-langselector-search-input"
            type="text"
            class="single-line-input peer"
            placeholder=" "
            autocomplete="off"
          />
          <label
            for="mach-core-langselector-search-input"
            class="floating-title"
          >
            {{ content.searchPlaceholder }}
          </label>

          <button
            *ngIf="searchValue"
            (click)="clearSearchField()"
            type="button"
            id="mach-core-langselector-search-input-clear"
            aria-label="Clear search"
            class="absolute right-12 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center !cursor-pointer"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Desktop Layout -->
      <div class="hidden tablet:grid grid-cols-2 gap-32">
        <!-- Regions -->
        <div *ngIf="!searchValue" id="mach-core-langselector-regions">
          <h3
            class="text-label-md-semibold text-heading mb-16 p-[4px]"
            id="mach-core-langselector-regions-title"
          >
            {{ content.region }}
          </h3>
          <ul
            class="space-y-8 max-h-[240px] p-[8px] overflow-y-auto overflow-x-hidden"
            id="mach-core-langselector-regions-list"
          >
            <li
              *ngFor="let region of content.regionList; index as i"
              [style.background-color]="
                region === content.selectedRegion ? '#f2f2f2' : ''
              "
              [ngClass]="{ active: region === content.selectedRegion }"
              aria-live="assertive"
              [id]="'mach-core-langselector-region-' + i"
            >
              <a
                tabindex="0"
                (click)="onRegionClicked(region, i)"
                (keydown.enter)="onRegionClicked(region, i)"
                class="link link-md block !w-full p-4 rounded-01 !border-b-0 !text-[#0b1f66]"
                [class.text-heading]="region === content.selectedRegion"
                aria-atomic="true"
                [id]="'mach-core-langselector-region-link-' + i"
              >
                {{
                  getTranslatedRegionName(region, content.currentCLSLanguage)
                }}
                <span *ngIf="region === content.selectedRegion" class="sr-only">
                  selected
                </span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Languages -->
        <div *ngIf="!searchValue" id="mach-core-langselector-languages">
          <h3
            class="text-label-md-semibold text-heading mb-16 p-[4px]"
            id="mach-core-langselector-languages-title"
          >
            {{ content.location }}
          </h3>
          <ul
            class="space-y-8 max-h-[240px] p-[8px] overflow-y-auto overflow-x-hidden"
            id="mach-core-langselector-languages-list"
          >
            <ng-template
              [ngForOf]="sortCountries(content.selectedRegionCountries)"
              let-country
              let-countryIndex="index"
              ngFor
            >
              <li
                *ngFor="
                  let language of sortLanguages(country.languageDtls);
                  index as langIndex
                "
                [id]="
                  'mach-core-langselector-language-' +
                  countryIndex +
                  '-' +
                  langIndex
                "
              >
                <a
                  tabindex="0"
                  [attr.data-acdl-action]="'footer:country and language:selection'"
                  [attr.data-acdl-page-section]="
                    'footer:country and language:selection:' +
                    language.countryName +
                    ' - ' +
                    language.languageName
                  "
                  (click)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  (keydown.enter)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  class="link link-md block !w-full p-4 rounded-01 !border-b-0"
                  [id]="
                    'mach-core-langselector-language-link-' +
                    countryIndex +
                    '-' +
                    langIndex
                  "
                >
                  {{ language.countryName + ' - ' + language.languageName }}
                </a>
              </li>
            </ng-template>
          </ul>
        </div>

        <!-- Search Results -->
        <div
          *ngIf="searchValue && searchValue.length > 0"
          class="col-span-2"
          id="mach-core-langselector-search-results"
        >
          <ul class="space-y-8" id="mach-core-langselector-search-results-list">
            <ng-template
              [ngForOf]="sortCountries(searchList)"
              let-country
              let-countryIndex="index"
              ngFor
            >
              <li
                *ngFor="
                  let language of country.languageDtls;
                  index as langIndex
                "
                [id]="
                  'mach-core-langselector-search-result-' +
                  countryIndex +
                  '-' +
                  langIndex
                "
              >
                <a
                  tabindex="0"
                  [attr.data-acdl-action]="'footer:country and language:selection'"
                  [attr.data-acdl-page-section]="
                    'footer:country and language:selection:' +
                    language.countryName +
                    ' - ' +
                    language.languageName
                  "
                  (click)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  (keydown.enter)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  class="link link-md block !w-full p-4 rounded-01 !border-b-0"
                  [id]="
                    'mach-core-langselector-search-result-link-' +
                    countryIndex +
                    '-' +
                    langIndex
                  "
                >
                  {{ language.countryName + ' - ' + language.languageName }}
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="tablet:hidden" id="mach-core-langselector-mobile">
        <div *ngIf="!searchValue" id="mach-core-langselector-mobile-regions">
          <div
            *ngFor="let region of content.regionList; index as i"
            [id]="'mach-core-langselector-mobile-region-' + i"
          >
            <details
              class="accordion accordion-base mb-16"
              [open]="i === activeIndex"
              [id]="'mach-core-langselector-mobile-region-details-' + i"
            >
              <summary
                [id]="'mach-core-langselector-mobile-region-summary-' + i"
              >
                <div
                  class="accordion-summary flex items-center gap-16"
                  (click)="onRegionClicked(region, i, true)"
                >
                  <span class="text-label-md-semibold text-heading flex-1">
                    {{
                      getTranslatedRegionName(
                        region,
                        content.currentCLSLanguage
                      )
                    }}
                  </span>
                  <div class="accordion-caret">
                    <svg
                      class="accordion-caret-icon text-icon-secondary !bg-[red]"
                      fill="red"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                      />
                    </svg>
                  </div>
                </div>
              </summary>
              <div
                class="accordion-content"
                [id]="'mach-core-langselector-mobile-region-content-' + i"
              >
                <ul
                  class="space-y-8"
                  [id]="'mach-core-langselector-mobile-region-list-' + i"
                >
                  <ng-template
                    [ngForOf]="sortCountries(content.selectedRegionCountries)"
                    let-country
                    let-countryIndex="index"
                    ngFor
                  >
                    <li
                      *ngFor="
                        let language of sortLanguages(country.languageDtls);
                        index as langIndex
                      "
                      [id]="
                        'mach-core-langselector-mobile-language-' +
                        i +
                        '-' +
                        countryIndex +
                        '-' +
                        langIndex
                      "
                    >
                      <a
                        tabindex="0"
                        [attr.data-acdl-action]="'footer:country and language:selection'"
                        [attr.data-acdl-page-section]="
                          'footer:country and language:selection:' +
                          language.countryName +
                          ' - ' +
                          language.languageName
                        "
                        (click)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode,
                            $event
                          )
                        "
                        (keydown.enter)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode,
                            $event
                          )
                        "
                        class="link link-md block !w-full p-8 pl-16 rounded-01 !border-b-0"
                        [id]="
                          'mach-core-langselector-mobile-language-link-' +
                          i +
                          '-' +
                          countryIndex +
                          '-' +
                          langIndex
                        "
                      >
                        {{
                          language.countryName + ' - ' + language.languageName
                        }}
                      </a>
                    </li>
                  </ng-template>
                </ul>
              </div>
            </details>
          </div>
        </div>

        <!-- Mobile Search Results -->
        <div
          *ngIf="searchValue && searchValue.length > 0"
          id="mach-core-langselector-mobile-search-results"
        >
          <ul
            class="space-y-8"
            id="mach-core-langselector-mobile-search-results-list"
          >
            <ng-template
              [ngForOf]="sortCountries(searchList)"
              let-country
              let-countryIndex="index"
              ngFor
            >
              <li
                *ngFor="
                  let language of country.languageDtls;
                  index as langIndex
                "
                [id]="
                  'mach-core-langselector-mobile-search-result-' +
                  countryIndex +
                  '-' +
                  langIndex
                "
              >
                <a
                  tabindex="0"
                  [attr.data-acdl-action]="'footer:country and language:selection'"
                  [attr.data-acdl-page-section]="
                    'footer:country and language:selection:' +
                    language.countryName +
                    ' - ' +
                    language.languageName
                  "
                  (click)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  (keydown.enter)="
                    afterLanguageSelected(
                      language.languageCode,
                      country.isoCode,
                      $event
                    )
                  "
                  class="link link-md block p-8 rounded-01 !border-b-0"
                  [id]="
                    'mach-core-langselector-mobile-search-result-link-' +
                    countryIndex +
                    '-' +
                    langIndex
                  "
                >
                  {{ language.countryName + ' - ' + language.languageName }}
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Backdrop Close Method -->
  <form method="dialog" class="pop-up-backdrop hidden laptop:block">
    <button (click)="close()" aria-label="Close pop-up">Close</button>
  </form>
</dialog>
